
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { BehaviorSubject } from 'rxjs';


@Injectable()
export class SnackBarService {

  constructor() { }

  private snackbarAnnouncedSource = new Subject<string>();
  // Observable string streams
  snackbarAnnounced$ = this.snackbarAnnouncedSource.asObservable();
  // Service message commands
  announceSackBar(snackbar: string) {
    this.snackbarAnnouncedSource.next(snackbar);
  }

} 